{
  "method": {
    "bankTransfer": "تحويل بنكي",
    "cash": "نقداً"
  },
  "home": {
    "remaining": "المتبقي لك",
    "agreement": "اتفاقيتك: {{label}}",
    "noAgreement": "لا توجد اتفاقية سارية",
    "agreementFile": "ملف الاتفاقية",
    "upcoming": "اتفاقية جديدة تبدأ في {{date}}",
    "upcomingFile": "ملف الاتفاقية القادمة",
    "earned": "المستحق",
    "transferred": "المحوَّل",
    "pending": "معلّق",
    "pendingHint": "المعلّق: عمولة حجوزات لم يدفعها العميل بعد، وتصبح مستحقة بعد الدفع.",
    "lastPayout": "آخر تحويل:",
    "tapForReceipt": "اضغط لعرض الإيصال",
    "recent": "أحدث حجوزاتي",
    "all": "الكل",
    "noBookings": "لا توجد حجوزات بعد",
    "hello": "مرحباً {{name}}",
    "whatsapp": "رقم واتساب الوكالة المخصص لك",
    "whatsappHint": "للتواصل مع العملاء"
  },
  "bookings": {
    "title": "عمولاتي",
    "month": "الشهر",
    "filterLabel": "تصفية حسب حالة العمولة",
    "all": "الكل",
    "total": "{{n}} حجوزات",
    "shareTotal": "مجموع حصتك:",
    "empty": "لا توجد حجوزات مطابقة"
  },
  "payouts": {
    "title": "التحويلات والإيصالات",
    "transferredTotal": "إجمالي المحوَّل",
    "remaining": "المتبقي لك",
    "covers": "يغطي {{n}} حجوزات",
    "voided": "ملغى",
    "viewReceipt": "عرض الإيصال",
    "empty": "لا توجد تحويلات بعد",
    "hint": "تظهر التحويلات هنا فور تسجيلها من الإدارة مع إيصال التحويل."
  },
  "receipt": {
    "back": "رجوع",
    "title": "تحويل {{date}}",
    "alt": "إيصال التحويل {{name}}",
    "download": "تحميل الإيصال",
    "entries": "الحجوزات المشمولة",
    "crumb": "الإيصال"
  },
  "notifications": {
    "title": "الإشعارات",
    "emptyTitle": "لا توجد إشعارات",
    "emptyDescription": "ستظهر هنا أي تغييرات على اتفاقيتك.",
    "cancelled": {
      "title": "إلغاء اتفاقية مجدولة",
      "body": "أُلغيت الاتفاقية ({{terms}} من رسم كل حجز) التي كانت ستبدأ في {{day}}. تستمر اتفاقيتك الحالية."
    },
    "changed": {
      "title": "تم تحديث اتفاقيتك",
      "body": "أصبحت اتفاقيتك {{terms}} من رسم كل حجز، وتسري من {{day}}."
    },
    "scheduled": {
      "title": "اتفاقية جديدة مجدولة",
      "titleUpdated": "تعديل اتفاقية مجدولة",
      "body": "اتفاقيتك القادمة: {{terms}} من رسم كل حجز، تبدأ من {{day}}."
    }
  },
  "my": {
    "title": "حجوزاتي",
    "earnings": "عمولاتي",
    "new": "حجز جديد",
    "search": "بحث في حجوزاتي",
    "searchPlaceholder": "رقم الحجز، العميل، الجوال",
    "filterLabel": "تصفية حسب حالة الحجز",
    "all": "الكل",
    "share": "حصتك:",
    "empty": "لا توجد حجوزات بعد",
    "count": "{{n}} حجزاً",
    "columns": {
      "reference": "رقم الحجز",
      "customer": "العميل",
      "partner": "الشريك",
      "fee": "الرسم",
      "share": "حصتك",
      "status": "الحالة",
      "date": "التاريخ"
    }
  },
  "form": {
    "back": "رجوع",
    "newTitle": "حجز جديد",
    "editTitle": "تعديل {{ref}}",
    "parties": "أطراف الحجز",
    "customer": "العميل",
    "customerPlaceholder": "ابحث بالاسم أو الجوال",
    "customerSearch": "اسم العميل أو رقم الجوال",
    "noCustomers": "لا يوجد عملاء مطابقون",
    "newCustomer": "عميل جديد",
    "partner": "الشريك",
    "partnerPlaceholder": "اختر الشريك",
    "partnerSearch": "اسم الشريك",
    "noPartners": "لا يوجد شركاء نشطون",
    "confirmation": "رقم تأكيد الشريك",
    "optional": "اختياري",
    "amounts": "المبالغ والفاتورة",
    "bookingAmount": "قيمة الحجز ({{currency}})",
    "fee": "رسوم الخدمة ({{currency}})",
    "yourShare": "اتفاقيتك: {{label}}",
    "billingMode": "وضع الفاتورة",
    "summary": "ملخص الحساب",
    "myShare": "حصتك",
    "invoiceTotal": "الإجمالي على العميل",
    "confirm": "تأكيد الحجز",
    "saveDraft": "حفظ كمسودة",
    "saveChanges": "حفظ التعديلات",
    "saving": "جاري الحفظ…",
    "saved": "تم حفظ التعديلات",
    "confirmed": "تم تأكيد الحجز",
    "draftSaved": "تم حفظ المسودة",
    "failed": "تعذر الحفظ",
    "pickCustomer": "اختر العميل",
    "pickPartner": "اختر الشريك",
    "feePositive": "يجب أن يكون الرسم أكبر من صفر"
  },
  "detail": {
    "confirm": "تأكيد الحجز",
    "issueInvoice": "إصدار الفاتورة",
    "copyLink": "نسخ رابط الدفع",
    "retry": "إعادة محاولة الإرسال",
    "edit": "تعديل",
    "details": "تفاصيل الحجز",
    "phone": "الجوال",
    "bookingAmount": "قيمة الحجز",
    "fee": "رسوم الخدمة",
    "full": "فاتورة كاملة",
    "feeOnly": "رسوم الخدمة فقط",
    "timeline": "سجل الأحداث",
    "invoice": "الفاتورة",
    "total": "الإجمالي",
    "due": "تستحق في",
    "noInvoice": "لم تصدر فاتورة بعد. أكّد الحجز ثم أصدر الفاتورة لترسل للعميل برابط الدفع.",
    "linkCopied": "تم نسخ رابط الدفع",
    "done": {
      "confirm": "تم تأكيد الحجز",
      "invoice": "تم إصدار الفاتورة، جاري الإرسال إلى StreamPay",
      "retry": "أُعيدت محاولة الإرسال"
    }
  },
  "agreements": {
    "title": "اتفاقيتي",
    "hint": "اتفاقياتك الحالية والقادمة والسابقة، مع ملف كل اتفاقية.",
    "empty": "لا توجد اتفاقيات",
    "range": "من {{from}} إلى {{to}}",
    "openRange": "من {{from}} — مفتوحة",
    "view": "عرض",
    "download": "تحميل الاتفاقية",
    "noFile": "لا يوجد ملف مرفق لهذه الاتفاقية"
  },
  "customers": {
    "title": "العملاء",
    "subtitle": "{{n}} عميلاً",
    "searchLabel": "بحث في العملاء",
    "searchPlaceholder": "الاسم، الجوال",
    "new": "عميل جديد",
    "emptyTitle": "لا يوجد عملاء",
    "noMatches": "لا توجد نتائج مطابقة للبحث.",
    "addFirst": "سجّل أول عميل للبدء.",
    "columns": {
      "name": "العميل",
      "phone": "الجوال",
      "email": "البريد"
    },
    "myBookings": "حجوزاتي معه",
    "added": "تاريخ التسجيل",
    "newBooking": "حجز جديد لهذا العميل",
    "edit": "تعديل",
    "myBookingsTitle": "حجوزاتي لهذا العميل",
    "noBookings": "لا توجد حجوزات"
  }
}
